import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";
import classes from "./TopBar.module.css";

export default function TopBar() {
  return (
    <div className={classes.topBar}>
      <div className={classes.container}>
        <div className={classes.content}>
          {/* Left Section */}
          <p className={classes.leftText}>
            Trusted provider of high-performance IT hardware and networking
            solutions.{" "}
            <Link to="/about-us" className={classes.link}>
              Learn more
            </Link>
          </p>

          {/* Right Section */}
          <div className={classes.right}>
            <a href="tel:+18444211258" className={classes.item}>
              <FaPhoneAlt />
              <span>1-844-421-1258</span>
            </a>

            <a
              href="mailto:sales@primecloudsystems.com"
              className={classes.item}
            >
              <FaEnvelope />
              <span>sales@primecloudsystems.com</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
